import { useEffect } from "react"

export default function Reload() {
  useEffect(() => {
    window.location.reload()
  }, [])

  return null
}
